export const EARLY_RELEASE_NOTICE_PARAGRAPHS = [
  'Student Assistant is an early-release service provided in good faith to help families organize schoolwork, schedules, and reminders. We are not experts; Student Assistant is not a school system and does not provide professional advice.',
  'AI responses can be incorrect, and information may be incomplete or out of date. Reminders may be missed or delayed. Check important information against official school sources and do not use Student Assistant for emergencies.',
  'Parents and guardians are responsible for supervising their child’s use, verifying information, and making sure assignments and other obligations are met.',
  'Families choose to use the service at their own risk. To the extent permitted by applicable law, the Student Assistant team disclaims liability for errors, service failures, missed or delayed reminders, and resulting losses. This notice does not eliminate responsibilities or limit rights that cannot legally be waived.',
];

export function EarlyReleaseNotice({
  version,
  acceptedAt,
  acceptedVersion,
  supportEmail = 'studentassistantsupport@gmail.com',
}: {
  version: string;
  acceptedAt?: string;
  acceptedVersion?: string;
  supportEmail?: string;
}) {
  return (
    <section className="card early-release-notice" aria-labelledby="early-release-title">
      <h2 id="early-release-title" tabIndex={-1}>Early release: what families should know</h2>
      <p className="early-release-lede">Student Assistant is an early-release service. AI information may be wrong or incomplete,
        reminders may be missed or late, and parents should verify important details and supervise use.</p>
      <details className="early-release-details">
        <summary>Read the full early-release notice</summary>
        {EARLY_RELEASE_NOTICE_PARAGRAPHS.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      <p className="muted" style={{ marginBottom: 0 }}>
        Current notice version: <strong>{version}</strong>
        {acceptedAt && acceptedVersion === version && (
          <> · Your acknowledgment was recorded {new Date(acceptedAt).toLocaleString()}.</>
        )}
      </p>
      <p style={{ marginBottom: 0 }}>Questions? <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.</p>
      </details>
      <p className="early-release-acknowledgment muted">
        {acceptedAt && acceptedVersion === version
          ? `Notice acknowledged on ${new Date(acceptedAt).toLocaleDateString()}.`
          : 'Review the full notice before recording your acknowledgment in permissions.'}
      </p>
    </section>
  );
}
